import React from 'react'
import { useParams } from 'react-router-dom'
import { UserLayout } from 'components/layout/UserLayout'
import { FullPageHeader } from 'components/layout/FullPageLayout/Header/FullPageHeader'
import { useSprintPacket } from 'hooks/api/useSprintPackets'
import { PacketEditorBody } from './editor/PacketEditorBody'
import { usePacketFonts } from './usePacketFonts'

export function EditSprintPacket() {
  usePacketFonts()
  const { businessID, packetID } = useParams<{ businessID: string; packetID: string }>()
  const packetIDNum = Number(packetID)
  const { packet } = useSprintPacket(packetIDNum)

  const sprintCrumb = packet?.sprint?.name ?? 'Sprint'
  const breadcrumbs = [
    { title: 'Sprint Packets', route: `/${businessID}/sprint-packets` },
    { title: sprintCrumb },
    { title: 'Edit' },
  ]

  return (
    <UserLayout>
      <FullPageHeader breadcrumbs={breadcrumbs} />
      <PacketEditorBody businessID={Number(businessID)} packetID={packetIDNum} />
    </UserLayout>
  )
}
